import type { TUploadSettings } from '../hooks/useAudioUploadFlow'

type TPendingHandover = {
    batchId: string
    settings: TUploadSettings
    entries: { fileId: string; file: File }[]
}

let pending: TPendingHandover | null = null

export const setPendingHandover = (handover: TPendingHandover): void => {
    pending = handover
}

export const consumePendingHandover = (): TPendingHandover | null => {
    const taken = pending

    pending = null

    return taken
}
